import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import Separator from "@/components/ux/separator"
import Logo from "@/components/logo"
import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"

interface HomeFrameProps {
  token: string;
  shortId: string;
  children: React.ReactNode;
}

export default function HomeFrame({
  token,
  shortId,
  children,
}: HomeFrameProps) {
  return (
    <Card className="shadow-md">
      <CardHeader>
        <CardTitle>Pay With {token}</CardTitle>
        <CardDescription>
          How would you like to make this payment?
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {children}
        <Separator>OR</Separator>
        <Button variant="outline" size="lg" asChild>
          <Link
            to={`/${shortId}/pay-with-balance`}
            data-testid="pay-with-balance"
          >
            Pay with <Logo size="small" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  )
}
